import { render } from "./ButtonComp.vue?vue&type=template&id=667ece3f"
import script from "./ButtonComp.vue?vue&type=script&lang=js"
export * from "./ButtonComp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__